/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ok': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zm21.142-78.484L66.93 90.81 54.216 76.09c-1.59-1.85-3.974-1.597-5.318.588-1.345 2.188-1.16 5.467.427 7.316l15.346 17.829c.733.84 1.59 1.176 2.445 1.176.98 0 1.956-.506 2.69-1.515l32.094-44.66c1.467-2.016 1.467-5.298 0-7.315-1.406-2.014-3.792-2.014-5.258.006z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
